import React, { createContext, useContext, useState, useCallback } from 'react';

const ContactContext = createContext(null);

export function ContactProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [prefill, setPrefill] = useState({});

  const openContact = useCallback((data = {}) => {
    setPrefill(data);
    setIsOpen(true);
    document.body.style.overflow = 'hidden';
  }, []);

  const closeContact = useCallback(() => {
    setIsOpen(false);
    document.body.style.overflow = '';
    setPrefill({});
  }, []);

  return (
    <ContactContext.Provider value={{ isOpen, prefill, openContact, closeContact }}>
      {children}
    </ContactContext.Provider>
  );
}

export function useContact() {
  const ctx = useContext(ContactContext);
  if (!ctx) throw new Error('useContact must be used inside ContactProvider');
  return ctx;
}
